<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="hasTip"
      class="font-italic text-h6 font-weight-bold text-center my-3"
      >{{ getTipFromCart === 0 ? 'No tip' : 'Thanks for the tip!' }}</div
    >
    <BtnBaseBlue
      v-else
      class="mb-2 white--text"
      block
      depressed
      :large="_includes(['xs', 'sm'], $mq)"
      @click="initTip"
      :disabled="getPlacingOrder"
      >Add a Tip</BtnBaseBlue
    >
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _includes from 'lodash/includes'
import BtnBaseBlue from '@/components/BtnBaseBlue'
export default {
  name: 'CheckoutTip',
  components: { BtnBaseBlue },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getTipFromCart', 'getPlacingOrder', 'hasTip']),
  },
  methods: {
    ...mapActions('cart', ['initTip']),
    _includes,
  },
}
</script>
